import React from "react";
import styles from "./styles.module.scss";
import { Navigate, Route, Routes } from "react-router-dom";
import { LoginPage } from "./LoginPage";
import { ForgotPasswordPage } from "./ForgotPasswordPage";
import { RegisterPage } from "./RegisterPage";
import { MainLayout } from "./components/MainLayout";

export const AuthPage = () => {
	return (
		<div className={styles.pageContainer}>
			{/* Background Glow */}
			<div className={styles.backgroundGlow} />

			<Routes>
				<Route
					path="/login"
					element={
						<MainLayout>
							<LoginPage />
						</MainLayout>
					}
				/>
				<Route
					path="/create-account"
					element={
						<MainLayout
							isSecondary={true}
							subtitle="Crie sua conta e comece a usar o Med.IA hoje mesmo!"
						>
							<RegisterPage />
						</MainLayout>
					}
				/>
				<Route
					path="/forgot-password"
					element={
						<MainLayout subtitle="Recuperação de Senha">
							<ForgotPasswordPage />
						</MainLayout>
					}
				/>
				<Route
					path="*"
					element={
						<Navigate
							to="/login"
							replace
						/>
					}
				/>
			</Routes>
		</div>
	);
};
